import { render, staticRenderFns } from "./tasting_card.vue?vue&type=template&id=0040619e&scoped=true"
import script from "./tasting_card.vue?vue&type=script&lang=js"
export * from "./tasting_card.vue?vue&type=script&lang=js"
import style0 from "./tasting_card.vue?vue&type=style&index=0&id=0040619e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040619e",
  null
  
)

export default component.exports